export default __webpack_public_path__ + "static/creditline-afs-00d20218c3ae9bd25bef67b14c6dded1.png";